import React from "react";
import Grid from '@mui/material/Grid2';
import { Box, Container, Typography } from "@mui/material";
import TelegramIcon from '@mui/icons-material/Telegram';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AndroidIcon from '@mui/icons-material/Android';
import IconButton from "@mui/material/IconButton";
import Divider from '@mui/material/Divider';
import { useUIConfig } from '../../hooks/config/useUIConfig';

const Footer = () => {
	
	const config = useUIConfig();

	return (
		<Container>
			<Divider/>
			<Grid container alignItems="center">
				<Grid size={4}>
					<Box>
						<Typography variant="subtitle1" color="gray" align="left" sx={{ p: 1 }}>
							Copyright © 2024 BlockWit
						</Typography>
					</Box>
				</Grid>

				<Grid size={4}>
					<Box
						display="flex"
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
						sx={{ gap: 0.5 }}
					>
						<Typography variant="subtitle1" color="gray" align="center">
							{config.config.version}
						</Typography>
						<Box
							component="a"
							href="/download/han.apk"
							download
							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: 1,
								textDecoration: 'none',
								color: '#4CAF50',
								transition: 'color 0.3s ease',
								'&:hover': {
									color: '#388E3C',
								},
							}}
						>
							<AndroidIcon sx={{ fontSize: 20 }} />
							<Typography variant="body2" fontWeight="bold">
								Download Android App
							</Typography>
						</Box>
					</Box>
				</Grid>

				<Grid size={4}>
					<Box align="right">
						<IconButton color="inherit" href="https://t.me/now_and_here"><TelegramIcon /></IconButton>
						{/* <IconButton color="inherit" href="/"><FacebookIcon /></IconButton>
						<IconButton color="inherit" href="/"><InstagramIcon /></IconButton>
						<IconButton color="inherit" href="/"><TwitterIcon /></IconButton>
						<IconButton color="inherit" href="/"><YouTubeIcon /></IconButton> */}
					</Box>
				</Grid>
{/* 
				<Grid size={4}>
					<Box>
						<Typography variant="body2" color="gray" align="left" sx={{ p: 1 }}>
							Copyright © 2024 BlockWit
						</Typography>
					</Box>
				</Grid> */}
			</Grid>
		</Container>
	);
};

export default Footer;
